import { withScrollListener } from '../components/hocs/scroll';
import * as ROUTES from './routes';

import SelectEvent from '../containers/events/SelectEvent';
import Home from '../containers/Home';
import Login from '../containers/authentication/Login';
import ForgotPassword from '../containers/authentication/ForgotPassword';
import ChangePassword from '../containers/authentication/ChangePassword';
import PasswordChangeSuccess from '../components/application/authentication/PasswordChangeSuccess';
import ForgotPasswordMail from '../containers/authentication/ForgotPasswordMail';
import Timetable from '../containers/events/Timetable';
import ContractInbox from '../containers/contracts/Inbox';
import ContractReview from '../containers/contracts/Review';
import AdminOrganizations from '../containers/admin/organizations/Index';
import AdminOrganizationsDetails from '../containers/admin/organizations/Details';
import AdminEvents from '../containers/admin/events/Index';
import AdminEventsDetails from '../containers/admin/events/Details';
import AdminContacts from '../containers/admin/contacts/Index';
import AdminContactsDetails from '../containers/admin/contacts/Details';
import AdminPartners from '../containers/admin/partners/Index';
import AdminPartnersDetails from '../containers/admin/partners/Details';
import AdminArtists from '../containers/admin/artists/Index';
import AdminArtistsDetails from '../containers/admin/artists/Details';
import AdminContracts from '../containers/admin/contracts/Index';
import AdminContractsDetails from '../containers/admin/contracts/Details';
import AdminTemplateDetails from '../containers/admin/templates/Details';
import { PERMISSIONS } from './authentication/permissions';
import Privacy from '../containers/authentication/Privacy';
import TCO from '../containers/authentication/TermsAndConditions';
import ReviewSuccess from '../containers/contracts/ReviewSuccess';

// ROUTES MAPPING
export const ROUTES_MAPPING = {
    PUBLIC: [
        [ROUTES.LOGIN_PATH, Login],
        [ROUTES.PRIVACY_PATH, Privacy],
        [ROUTES.TCO_PATH, TCO],
        [ROUTES.FORGOT_PASSWORD_PATH, ForgotPassword],
        [ROUTES.FORGOT_PASSWORD_MAIL_PATH, ForgotPasswordMail],
        [ROUTES.REVIEW_SUCCESS_PATH, ReviewSuccess],
        [ROUTES.REVIEW_PATH, ContractReview]
    ],
    PRIVATE: [
        [ROUTES.ROOT_PATH, Home],
        [ROUTES.INDEX_PATH, Home],
        [ROUTES.EVENTS_PATH, SelectEvent],
        [ROUTES.CONTRACTS_PATH, ContractInbox],
        [ROUTES.CONTRACT_PATH, ContractReview],
        [ROUTES.TIMETABLE_PATH, withScrollListener(Timetable)],
        [ROUTES.CHANGE_PASSWORD_PATH, ChangePassword],
        [ROUTES.CHANGE_PASSWORD_SUCCESS_PATH, PasswordChangeSuccess]
    ],
    ADMIN: [
        [ROUTES.ADMIN_ROOT_PATH, AdminOrganizations, PERMISSIONS.ACCESS_ADMIN],
        [ROUTES.ADMIN_ORGS_PATH, AdminOrganizations, PERMISSIONS.GOD],
        [ROUTES.ADMIN_ORG_NEW_PATH, AdminOrganizationsDetails, PERMISSIONS.GOD],
        [ROUTES.ADMIN_ORG_DETAILS_PATH, AdminOrganizationsDetails, PERMISSIONS.ACCESS_ADMIN],

        [ROUTES.ADMIN_EVENTS_PATH, AdminEvents, PERMISSIONS.EVENTS_VIEW],
        [ROUTES.ADMIN_ORG_EVENTS_PATH, AdminEvents, PERMISSIONS.EVENTS_VIEW],
        [ROUTES.ADMIN_EVENTS_NEW_PATH, AdminEventsDetails, PERMISSIONS.EVENTS_ADD],
        [ROUTES.ADMIN_ORG_EVENTS_NEW_PATH, AdminEventsDetails, PERMISSIONS.EVENTS_ADD],
        [ROUTES.ADMIN_ORG_EVENTS_DETAILS_PATH, AdminEventsDetails, PERMISSIONS.EVENTS_VIEW],
        [ROUTES.ADMIN_EVENTS_DETAILS_PATH, AdminEventsDetails, PERMISSIONS.EVENTS_VIEW],

        [ROUTES.ADMIN_PARTNERS_PATH, AdminPartners, PERMISSIONS.PARTNERS_VIEW],
        [ROUTES.ADMIN_ORG_PARTNERS_PATH, AdminPartners, PERMISSIONS.PARTNERS_VIEW],
        [ROUTES.ADMIN_PARTNERS_NEW_PATH, AdminPartnersDetails, PERMISSIONS.PARTNER_ADD],
        [ROUTES.ADMIN_ORG_PARTNERS_NEW_PATH, AdminPartnersDetails, PERMISSIONS.PARTNER_ADD],
        [ROUTES.ADMIN_ORG_PARTNERS_DETAILS_PATH, AdminPartnersDetails, PERMISSIONS.PARTNERS_VIEW],
        [ROUTES.ADMIN_PARTNERS_DETAILS_PATH, AdminPartnersDetails, PERMISSIONS.PARTNERS_VIEW],

        [ROUTES.ADMIN_CONTACTS_PATH, AdminContacts, PERMISSIONS.CONTACTS_VIEW],
        [ROUTES.ADMIN_ORG_CONTACTS_PATH, AdminContacts, PERMISSIONS.CONTACTS_VIEW],
        [ROUTES.ADMIN_CONTACTS_NEW_PATH, AdminContactsDetails, PERMISSIONS.CONTACT_ADD],
        [ROUTES.ADMIN_ORG_CONTACTS_NEW_PATH, AdminContactsDetails, PERMISSIONS.CONTACT_ADD],
        [ROUTES.ADMIN_CONTACTS_DETAILS_PATH, AdminContactsDetails, PERMISSIONS.CONTACTS_VIEW],
        [ROUTES.ADMIN_ORG_CONTACTS_DETAILS_PATH, AdminContactsDetails, PERMISSIONS.CONTACTS_VIEW],

        [ROUTES.ADMIN_ARTISTS_PATH, AdminArtists, PERMISSIONS.ARTISTS_VIEW],
        [ROUTES.ADMIN_ORG_ARTISTS_PATH, AdminArtists, PERMISSIONS.ARTISTS_VIEW],
        [ROUTES.ADMIN_ARTISTS_NEW_PATH, AdminArtistsDetails, PERMISSIONS.ARTIST_ADD],
        [ROUTES.ADMIN_ORG_ARTISTS_NEW_PATH, AdminArtistsDetails, PERMISSIONS.ARTIST_ADD],
        [ROUTES.ADMIN_ARTISTS_DETAILS_PATH, AdminArtistsDetails, PERMISSIONS.ARTISTS_VIEW],
        [ROUTES.ADMIN_ORG_ARTISTS_DETAILS_PATH, AdminArtistsDetails, PERMISSIONS.ARTISTS_VIEW],

        [ROUTES.ADMIN_CONTRACTS_PATH, AdminContracts],
        [ROUTES.ADMIN_ORG_CONTRACTS_PATH, AdminContracts],
        [ROUTES.ADMIN_CONTRACTS_NEW_PATH, AdminContractsDetails],
        [ROUTES.ADMIN_ORG_CONTRACTS_NEW_PATH, AdminContractsDetails],
        [ROUTES.ADMIN_CONTRACTS_DETAILS_PATH, AdminContractsDetails],
        [ROUTES.ADMIN_ORG_CONTRACTS_DETAILS_PATH, AdminContractsDetails],

        [ROUTES.ADMIN_TEMPLATES_NEW_PATH, AdminTemplateDetails, PERMISSIONS.TEMPLATE_ADD],
        [ROUTES.ADMIN_ORG_TEMPLATES_NEW_PATH, AdminTemplateDetails, PERMISSIONS.TEMPLATE_ADD],
        [ROUTES.ADMIN_TEMPLATES_DETAILS_PATH, AdminTemplateDetails, PERMISSIONS.TEMPLATE_EDIT],
        [ROUTES.ADMIN_ORG_TEMPLATES_DETAILS_PATH, AdminTemplateDetails, PERMISSIONS.TEMPLATE_EDIT]
    ]
};



// WEBPACK FOOTER //
// ./src/constants/routing.js